import { render, staticRenderFns } from "./home_page.vue?vue&type=template&id=2efade50&scoped=true"
import script from "./home_page.vue?vue&type=script&lang=js"
export * from "./home_page.vue?vue&type=script&lang=js"
import style0 from "./home_page.vue?vue&type=style&index=0&id=2efade50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efade50",
  null
  
)

export default component.exports